import { CalendarDays, GraduationCap, Home, MessageSquare, User } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { ModuleKey } from '@/access/modules';

export type NavItem = {
  to: string;
  label: string;
  icon: LucideIcon;
  /** undefined = ליבה, תמיד מוצג. אחרת מוצג רק כשהמודול פעיל. */
  module?: ModuleKey;
  /** מפתח הרשאה נדרש, אם יש. */
  perm?: string;
};

/**
 * מבנה התפריט. פריט של מודול כבוי לא מוצג: פחות פריטים, אותה רשת.
 * אין כאן תוכן של לקוח, רק מסכי המערכת.
 */
export const EMPLOYEE_NAV: NavItem[] = [
  { to: '/', label: 'בית', icon: Home },
  { to: '/schedule', label: 'סידור', icon: CalendarDays, module: 'schedule' },
  { to: '/messages', label: 'הודעות', icon: MessageSquare, module: 'messages' },
  // המפתח הוא תת הפיצ'ר ולא ההורה: מי שכיבה "לומדות וחידונים"
  // ציפה שהטאב ייעלם, והנתיב עצמו כבר שמור באותו מפתח
  { to: '/learning', label: 'לומדות', icon: GraduationCap, module: 'learning_courses' },
  { to: '/me', label: 'האזור שלי', icon: User },
];
